<template>
  <div >
    <div v-loading="loading">
      <div style="display:flex;margin-top:10px;" >
        <div style="height:20px;border-left:3px solid #1884f2; margin-right:10px;"></div>
        <el-descriptions title="用户信息" >
          <el-descriptions-item :labelStyle="{'margin-bottom': '8px'}" label="姓名" >{{form.userName}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="性别" >{{form.sex==='1' ? '男' : '女'}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="年龄" >{{form.age}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="手机号" >{{form.phone}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="身份证号码" >{{form.idNum}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="证件有效日期" >{{form.certificateValidity}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="民族" >{{form.nationality}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="出生年月" >{{form.birthday}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="所在地区" >
            <el-tooltip class="item" effect="dark" :content="locality" placement="top-start">
              <div style="width:350px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{locality}}
              </div>
            </el-tooltip>
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="身份证地址" >
            <el-tooltip class="item" effect="dark" :content="form.address" placement="top-start">
              <div style="width:350px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{form.address}}
              </div>
            </el-tooltip>
          </el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="学历" >{{form.highestEducation}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="婚姻状况" >{{form.maritalStatus}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="身高（厘米）" >{{form.height}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="体重（斤）" >{{form.weight}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="户籍类型" >{{form.registeredResidenceType ? form.registeredResidenceType==='0' ? '农村' : '城镇' : ''}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="现住址" >{{form.liveAddress}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="穿衣尺码" >{{form.dressSize}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="政治面貌" >{{form.politicsStatus}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="display:flex;margin-top:30px;">
        <div style="height:20px;border-left:3px solid #1884f2; margin-right:10px;"></div>
        <el-descriptions title="紧急联系人">
          <el-descriptions-item label="紧急联系人姓名" >{{form.emergencyContact}}</el-descriptions-item>
          <el-descriptions-item label="联系人电话" >{{form.emergencyContactPhone}}</el-descriptions-item>
          <el-descriptions-item label="联系人关系" >{{form.emergencyContactRelation}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="display:flex;margin-top:30px;">
        <div style="height:20px;border-left:3px solid #1884f2; margin-right:10px;"></div>
        <el-descriptions title="工作信息">
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="所属部门" >{{form.deptNames}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="职级" >{{form.postName}}</el-descriptions-item>
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="员工状态" >{{form.jobStateDesc}}</el-descriptions-item>
<!--          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="试工日期" >{{form.probationDate}}</el-descriptions-item>-->
<!--          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="入职日期" >{{form.hiredDate}}</el-descriptions-item>-->
          <el-descriptions-item :labelStyle="{'margin-bottom': '10px'}" label="是否允许收银" >{{form.isCashierAllowed==='0'?'否':'是'}}</el-descriptions-item>
          <el-descriptions-item v-if="form.finalLeaveTime" :labelStyle="{'margin-bottom': '10px'}" label="离职日期" >{{form.finalLeaveTime}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="display:flex;margin-top:30px;">
        <div style="height:20px;border-left:3px solid #1884f2; margin-right:10px;"></div>
        <el-descriptions title="个人材料">
          <el-descriptions-item label="身份证（人像面）" >
            <el-button type="text" style="padding:0;" v-if="form.idCardImgFace" @click="checkImage('idCardImgFace')">查看图片</el-button>
          </el-descriptions-item>
          <el-descriptions-item label="身份证（国徽面）" >
            <el-button type="text" style="padding:0;" v-if="form.idCardImgFlag" @click="checkImage('idCardImgFlag')">查看图片</el-button>
          </el-descriptions-item>
          <el-descriptions-item label="全身照" >
            <el-button type="text" style="padding:0;" v-if="form.halfLengthPhoto" @click="checkImage('halfLengthPhoto')">查看图片</el-button>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <el-image-viewer class="image-view" v-if="showViewer" :on-close="closeViewer" :url-list="imageList" />
    </div>
  </div>
</template>

<script>
import tool from '@/utils/tool.js'
import newPostUrl from '@/libs/http/modules/oa.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  name:'userInfo',
  props: ['record'],
  components: {
    ElImageViewer,
  },
  data() {
    return {
      loading:false,
      activeName:'userInfo',
      showViewer: false,
      locality:'',
      form:{
        deptNames:'',
        flowState:'',
        jobStateDesc:'',
        isCashierAllowed:'',
        userName:'',
        sex:'',
        age:'',
        highestEducation:'',
        maritalStatus:'',
        // expectSalary:'',
        postName:'',
        // applyChannel:'',
        // applyChannelDesc:'',
        phone:'',
        // createTime:'',
        // updateTime:'',
        // createUserName:'',
        // updateUserName:'',

        probationDate:'',
        hiredDate:'',
        finalLeaveTime:'',

        halfLengthPhoto:'',
        idCardImgFace:'',
        idCardImgFlag:'',
        idNum:'',
        certificateValidity:'',
        nationality:'',
        birthday:'',
        province:'',
        city:'',
        area:'',
        address:'',
        height:'',
        weight:'',
        liveAddress:'',
        registeredResidenceType:'',
        dressSize:'',
        politicsStatus:'',
        emergencyContact:'',
        emergencyContactPhone:'',
        emergencyContactRelation:'',
      },
      imageList: [],
    }
  },
  created () {
    console.log('record=======',this.record)
  },
  watch:{
    record:{
      handler(newValue){
        if(this.record){
          this.fetch()
        }
      },
      deep:true,
      immediate:true
    }
  },
  methods: {
    checkImage(key){
      this.imageList = []
      this.imageList.push(this.form[key])
      this.showViewer=true
    },
    closeViewer(){
      this.showViewer = false
    },
    fetch() {
        this.loading = true
        this.$emit("loadingUserInfo",true);
        newPostUrl.queryFrontendUserDetail({userId: this.record.userId}).then((res)=>{
          for(let key in this.form){
            this.form[key] = res[key]
          }
          this.locality = ''
          if(res.province){
            this.locality = this.locality + res.province
          }
          if(res.city){
            this.locality = this.locality + res.city
          }
          if(res.area){
            this.locality = this.locality + res.area
          }
          this.loading = false
          this.$emit("loadingUserInfo",false);
        }).catch((error)=>{
          this.loading = false
          this.$emit("loadingUserInfo",false);
          if(error.msg){
            this.$message.error(error.msg)
          }else{
            this.$message.error(error)
          }
          console.log(error)
        })
    },

  },
}
</script>

<style lang="scss" scoped>
.image-view {
  z-index: 99999 !important;
}
.el-image-viewer {
  z-index: 99999 !important;
}
.myLabel{
  margin-bottom: 30px;
}
</style>